/**
 * Top-bar on/off for "Show call pops in this browser" (Zac, 2026-11-03: "a
 * toggle in the black top nav bar"). The same per-user, per-device setting as
 * Settings > Notifications, the Phones settings drawer, the call card's menu
 * and Ctrl+K. Shown with comms.view, like the other switches.
 */
import { IconButton, toast } from '@velora/ui';
import { PhoneCall, PhoneOff } from 'lucide-react';
import { usePermission } from '../../../app/shell.js';
import { useMyBrowserPops } from './browserPops.js';

export function CallPopsToggle() {
  const canView = usePermission('comms.view');
  const pops = useMyBrowserPops();
  if (!canView) return null;
  // Unknown (desktop app state still loading) reads as on, the browser default.
  const on = pops.enabled !== false;
  return (
    <IconButton
      label={on ? 'Call pops on: click to turn off' : 'Call pops off: click to turn on'}
      icon={on ? <PhoneCall size={16} /> : <PhoneOff size={16} />}
      variant="ghost"
      aria-pressed={on}
      data-state={on ? 'on' : 'off'}
      className="shell-callpops"
      onClick={() => {
        pops.set(!on);
        toast({
          id: 'callpop-browser',
          title: on ? 'Call pops off in this browser' : 'Call pops on in this browser',
          description: on ? 'Click the phone in the top bar to turn them back on.' : undefined,
        });
      }}
    />
  );
}
